import { getCategories as getCategoriesFromBackend } from '@client/connectivity/api.categories';
import { getSponsors as getSponsorsFromBackend } from '@client/connectivity/api.sponsors';
import { getAdminSeries as getSeriesFromBackend } from '@client/connectivity/api.series';

const LOAD = 'LOAD';
const ERROR = 'ERROR';
const SUCCESS = 'SUCCESS';

let defaultState = {
  items: undefined,
  loading: undefined,
  loadingError: undefined,
};

export const fetchingOptions = {
  category: {
    name: 'category',
    auth: false,
    fetchUrl: getCategoriesFromBackend,
  },
  sponsor: {
    name: 'sponsor',
    auth: true,
    fetchUrl: getSponsorsFromBackend,
  },
  series: {
    name: 'series',
    auth: true,
    fetchUrl: getSeriesFromBackend,
  },
};

function reducerKey(name) {
  return `${name}Reducer`;
}

export function loadingAction(name) {
  return LOAD + name;
}

export function errorAction(name) {
  return LOAD + ERROR + name;
}

export function resultAction(name) {
  return LOAD + SUCCESS + name;
}

function fetchDataReducer(
  state = defaultState,
  action = {},
  fetchingOptionsItem
) {
  switch (action.type) {
    case resultAction(fetchingOptionsItem.name): {
      return {
        ...state,
        loading: false,
        items: action.payload.items,
        loadingError: undefined,
      };
    }
    case errorAction(fetchingOptionsItem.name): {
      return {
        ...state,
        loading: false,
        loadingError: action.error,
      };
    }
    case loadingAction(fetchingOptionsItem.name): {
      return {
        ...state,
        loading: true,
      };
    }
  }
  return state;
}

export function fetchDataReducers() {
  const reducers = {};
  for (const fetchingOption of Object.values(fetchingOptions)) {
    reducers[reducerKey(fetchingOption.name)] = (
      state = defaultState,
      action = {}
    ) => fetchDataReducer(state, action, fetchingOption);
  }
  return reducers;
}

export const getLoadedCategories = (state) => {
  return getLoadedItems(state, fetchingOptions.category.name);
};

export const isLoadingCategories = (state) => {
  return isLoading(state, fetchingOptions.category.name);
};

export const getLoadedSponsors = (state) => {
  return getLoadedItems(state, fetchingOptions.sponsor.name);
};

export const isLoadingSponsors = (state) => {
  return isLoading(state, fetchingOptions.sponsor.name);
};

export const getLoadedSeries = (state) => {
  return getLoadedItems(state, fetchingOptions.series.name);
};

export const isLoadingSeries = (state) => {
  return isLoading(state, fetchingOptions.series.name);
};

export const getLoadedItems = (state, name) => {
  return state[reducerKey(name)].items;
};

export const isLoading = (state, name) => {
  return state[reducerKey(name)].loading;
};
